import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  content: {
    display: 'inline-flex',
    columnGap: theme.spacing(0.5),
    alignItems: 'center',
  },
  changedValue: {
    color: theme.palette.success.dark,
  },
  notFoundValue: {
    color: theme.palette.error.dark,
  },
  stacked: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(0.5),
  },
  inline: {
    display: 'flex',
    columnGap: theme.spacing(0.5),
    alignItems: 'center',
  },
  multiValueContainer: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: theme.spacing(0.5),
    '& > *:not(:last-child)::after': {
      content: '","',
    },
  },
}));

export default useStyles;
